import { mapActions, mapGetters } from 'vuex'
import SimpleText from '@/agilis/components/Text/Text.vue'
import validationMixin from '@/agilis/components/Form/utils/validationMixin.js'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

function walkTree (nodeId) {
  const tmp = nodeId.split('-')
  const output = []

  tmp.forEach((id, index) => {
    output.push(
      tmp.slice(0, index + 1).join('-')
    )
  })

  return output
}

export default {
  name: 'FormTree',
  mixins: [validationMixin, textFieldMixin],

  components: {
    SimpleText
  },

  props: {
    fieldConfig: Object,
    value: String,
    configTree: Array,
    onlyLeafSelectable: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      loading: false,
      menu: false,
      tree: null,
      innerValue: this.value,
      searchText: null,
      selectedNodes: this.value ? [this.value] : [],
      openNodes: this.value ? walkTree(this.value) : [],
      activeNodes: this.value ? [this.value] : [],
      openNodeSearch: []
    }
  },

  watch: {
    value (newValue, oldValue) {
      this.innerValue = newValue // react to changes in input prop

      if (newValue) { // Set inner vars when values arrives after the creation of the component
        this.selectedNodes = [this.value]
        this.openNodes = walkTree(this.value)
        this.activeNodes = [this.value]
      }
    },

    menu (newValue) {
      if (newValue && this.tree === null) this.fetchTree()
    },

    searchText (newValue) {
      this.openNodeSearch = []
      newValue ? this.openNodes = this.searchFilter(this.tree, newValue, 'name') : this.openNodes = []
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    async fetchTree () {
      this.loading = true
      this.configTree ? this.tree = this.configTree : this.tree = []
      this.loading = false
    },

    trigMenu () {
      if (!this.menu) this.menu = true
    },

    onSelectLeaf (newValue) {
      if (newValue.join('_') === this.selectedNodes.join('_')) { // Avoid loops
        return
      }

      if (newValue.length === 0) {
        this.selectedNodes = []
        this.innerValue = null
        this.$emit('input', null)
      } else {
        const id = newValue.pop()
        this.selectedNodes = [id]
        this.innerValue = id
        this.$emit('input', id)
      }
    },

    clearValue () {
      this.selectedNodes = []
      this.innerValue = null
      this.$emit('input', null)
    },

    searchFilter (tree, search, textKey) {
      tree.map(leaf => {
        if (leaf[textKey].toLowerCase().includes(search.toLowerCase()) ||
          (leaf.children && this.searchFilterInChildren(leaf.children, search, textKey))) {
          this.openNodeSearch = [...this.openNodeSearch, leaf['id']]
        }
        if (leaf.children) {
          return this.searchFilter(leaf.children, search, textKey)
        }
      })
      return this.openNodeSearch
    },

    searchFilterInChildren (children, search, textKey) {
      return children.map(leaf => {
        if (leaf[textKey].toLowerCase().includes(search.toLowerCase())) {
          return true
        }
        if (leaf.children) {
          return this.searchFilterInChildren(leaf.children, search, textKey)
        }
      })
    },

    getClass () {
      return this.onlyLeafSelectable !== false ? 'form-tree-onlyleaf' : ''
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      trackerTypeId: 'contextStore/trackerTypeId'
    }),

    filter () {
      return (tree, search, textKey) => {
        const s = search.toLowerCase()
        return tree?.[textKey]?.toLowerCase().indexOf(s) > -1 || tree?.['id']?.toLowerCase().indexOf(s) > -1
      }
    }
  }
}
